import { render, staticRenderFns } from "./ViewSystemMessages.vue?vue&type=template&id=47ea0f69&scoped=true&"
import script from "./ViewSystemMessages.vue?vue&type=script&lang=js&"
export * from "./ViewSystemMessages.vue?vue&type=script&lang=js&"
import style0 from "./ViewSystemMessages.vue?vue&type=style&index=0&id=47ea0f69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea0f69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ea0f69')) {
      api.createRecord('47ea0f69', component.options)
    } else {
      api.reload('47ea0f69', component.options)
    }
    module.hot.accept("./ViewSystemMessages.vue?vue&type=template&id=47ea0f69&scoped=true&", function () {
      api.rerender('47ea0f69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system-messages/ViewSystemMessages.vue"
export default component.exports